<template>
  <ion-page>
    <ion-content
      class="ion-padding-top bg-grad-content cart-content"
      fullscreen
    >
      <ion-list class="cart-list ion-padding-top">
        <ion-list-header class="ion-padding-top"
          >Carro de compras</ion-list-header
        >
        <ion-item
          v-for="(item, index) in items"
          :key="index"
          :class="index == 0 ? 'ion-padding-top' : ''"
        >
          <ion-thumbnail slot="end" @click="zoomImage(item.image)">
            <img v-lazy="item.image" />
          </ion-thumbnail>
          <ion-label>
            <h3 @click="$router.push(item.slug)">{{ item.name }}</h3>
            <p @click="$router.push(item.slug)">{{ item.ref }}</p>
            <ion-text color="primary">{{
              $filters.currencyFormat(item.price)
            }}</ion-text>
            <ion-footer>
              <ion-row>
                <ion-col class="ion-text-center">
                  <i
                    class="mdi mdi-cart-minus mdi-36px"
                    @click="setQtyProduct(item, 'minus')"
                  ></i>
                  <ion-badge color="primary">{{ item.quantity }}</ion-badge>
                  <i
                    class="mdi mdi-cart-plus mdi-36px"
                    @click="setQtyProduct(item, 'plus')"
                  ></i>
                </ion-col>
                <ion-col class="ion-text-center" @click="delProduct(item)">
                  <i class="mdi mdi-trash-can-outline mdi-36px color-red"></i>
                </ion-col>
              </ion-row>
            </ion-footer>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
    <ion-footer class="footercart">
      <ion-grid>
        <ion-row>
          <ion-col
            class="ion-text-center"
            @click="items.length > 0 ? chekOut() : null"
          >
            <i class="mdi mdi-cart-check mdi-36px"></i>
          </ion-col>
          <ion-col class="ion-text-center">
            <a href="https://wa.me/573213813097?text=" target="_blank"
              ><i class="mdi mdi-whatsapp mdi-36px color-green"></i
            ></a>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="ion-text-center">
            <ion-text color="primary" class="total-text"
              >Total: {{ $filters.currencyFormat(cartTotalPrice) }}</ion-text
            >
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-footer>
  </ion-page>
</template>

<script>
import { alertController } from '@ionic/vue'
export default {
  components: {},
  // eslint-disable-next-line no-unused-vars
  data(vm) {
    return {}
  },
  ionViewDidEnter() {
    this.$emitter.emit('full-loader')
  },
  ionViewDidLeave() {},
  ionViewWillEnter() {
    if (!this.$store.getters['app/keepPageState']) {
      this.$emitter.emit('full-loader', { open: true })
    }
  },
  ionViewWillLeave() {},
  created() {},
  beforeUnmount() {},
  mounted() {},
  computed: {
    items() {
      return this.$store.state.cart.items
    },
    cartTotalPrice() {
      return this.$store.getters['cart/cartTotalPrice']
    }
  },
  methods: {
    chekOut() {
      this.$store.dispatch('app/messageData', {
        title: 'Quiero Comprar',
        cart: this.items
      })
      this.$store.dispatch('app/keepPageState', true)
      this.$router.push({ name: 'messageme' })
    },
    zoomImage(img) {
      this.$emitter.emit('zoom-image', { image: img })
    },
    async setQtyProduct(item, $event) {
      if (item.quantity == 1 && $event === 'minus') {
        const alert = await alertController.create({
          cssClass: 'cart-alert-confirm-delete',
          header: 'Atención',
          message:
            'Esta a punto de eliminar el producto del carro, desea continuar?',
          buttons: [
            {
              text: 'Cancelar',
              role: 'cancel',
              cssClass: 'secondary',
              handler: (blah) => {
                return
              }
            },
            {
              text: 'Continuar',
              handler: () => {
                this.$store.dispatch('cart/delItem', item.id)
                return
              }
            }
          ]
        })
        return alert.present()
      }
      let quantity = $event === 'minus' ? item.quantity - 1 : item.quantity + 1
      this.$store.dispatch('cart/qtySet', { id: item.id, qty: quantity })
    },
    async delProduct(item) {
      const alert = await alertController.create({
        cssClass: 'cart-alert-confirm-delete',
        header: 'Atención',
        message:
          'Esta a punto de eliminar el producto del carro, desea continuar?',
        buttons: [
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              return
            }
          },
          {
            text: 'Continuar',
            handler: () => {
              this.$store.dispatch('cart/delItem', item.id)
              return
            }
          }
        ]
      })
      return alert.present()
    }
  }
}
</script>

<style>
.total-text {
  background: white;
  padding: 8px;
  border-radius: 5px;
  font-weight: bold;
  color: black;
}
.footercart {
  background: rgba(0, 0, 0, 0.8);
  color: white;
}
.cart-content ion-badge {
  font-size: 20px;
  margin: 0px 5px;
  --padding-start: 10px;
  --padding-end: 10px;
}

.cart-alert-confirm-delete .alert-wrapper {
  background: var(--ion-color-step-200);
}
.text-alert-delete {
  color: red;
}

.cart-list ion-item {
  --background: transparent;
  --border-color: transparent;
}

.cart-list {
  background: transparent;
}
</style>
